<script>
  import { onMount } from 'svelte';
  import Confirm from '../components/confirm.svelte';
  import { deleteSiteSvc, getSite } from '../../services';
  import { goto } from '../../util';
  import { handleRedirect, pages } from '../../config';

  export let params;
  let site;

  $: sid = params?.sid;
  $: siteName = site?.domain || '';

  $: desc = `
  Are you sure you want to remove the site: ${siteName}?
  You will lose all of your forms, submissions and powerups. This is irreversible
  but you may make a new site with the same domain after this one is removed.
  `;

  onMount(async () => {
    site = await getSite({ sid });
  });

  function onCancel() {
    if (!handleRedirect(params.from, { sid }, goto)) {
      goto(pages.dashboard.url);
    }
  }
  async function onConfirm() {
    await deleteSiteSvc({ id: sid });
    if (!handleRedirect(params.from, { sid }, goto)) {
      goto(pages.dashboard.url);
    }
  }
</script>

<Confirm
  open
  title="Delete {siteName}?"
  {desc}
  cancelText="Cancel"
  confirmText="Delete"
  on:cancel={onCancel}
  on:confirm={onConfirm}
/>
